import { ListQueryParam, ListRange, SearchCriteriaBase } from '../../../../../../../../core/src/lib/common';

export class UserDeletionHistoryModel {
  timestamp: number;
  deletedBy: string;
  firstName: string;
  organizations: string[];
  userType: UserTypeEnum;

  constructor(params?: UserDeletionHistoryModel) {
    if (params) {
      Object.assign(this, params);
    }
  }
}

export enum UserTypeEnum {
  User = 'USER',
  TruckDriver = 'DRIVER',
}

export class UserDeletionHistoryListSearchCriteria extends SearchCriteriaBase {
  [ListQueryParam.Filter]: string;

  constructor(params?: UserDeletionHistoryListSearchCriteria | ListRange) {
    super();
    if (params) {
      Object.assign(this, params);
    }
  }
}
